import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-change-order-preview',
    templateUrl: './change-order-preview.component.html',
    styleUrls: ['./change-order-preview.component.scss'],
    standalone: false
})
export class ChangeOrderPreviewComponent implements OnInit {
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);

  public changeOrder: any = {};
  public drawing: any = {};

  constructor() { }

  ngOnInit(): void{
  this.model = this.model?.model;
  this.changeOrder =   this.form.get('step01').get('changeOrder').getRawValue();
  this.drawing =  this.form.get('step02').get('drawingForm').getRawValue();
  // console.log('Preview' ,  this.form);
  }

}
